import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './components/pages/Landing';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        {/* Kept for ad links: same landing, partnership form pre-opened */}
        <Route path="/early-access" element={<Landing initialModalOpen />} />
        {/* Legacy routes (privacy-policy, terms-of-use, payments) removed; old links land home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
